export const getPosterImage = (url: string): string => {
    if (!url) return "";

    try {
        const lowerUrl = url.toLowerCase();

        // YouTube
        if (lowerUrl.includes("youtu")) {
            const parsedUrl = new URL(url);
            let videoId = "";

            if (parsedUrl.searchParams.has("v")) {
                videoId = parsedUrl.searchParams.get("v") || "";
            } else {
                // fallback: laatste segment van path
                const segments = parsedUrl.pathname.split("/");
                videoId = segments[segments.length - 1];
            }

            return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
        }

        // Vimeo
        if (lowerUrl.includes("vimeo")) {
            const parsedUrl = new URL(url);
            const segments = parsedUrl.pathname.split("/");
            const videoId = segments[segments.length - 1];
            return `https://i.vimeocdn.com/video/${videoId}_1280.jpg`;
        }

        return "";
    } catch {
        return "";
    }
}